import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface ElderWisdomCardProps {
  name: string;
  image: string;
  alt: string;
  yearsMarried: number;
  wisdom: string;
  role: string;
}

const ElderWisdomCard = ({ name, image, alt, yearsMarried, wisdom, role }: ElderWisdomCardProps) => {
  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-sacred-md hover:shadow-sacred-lg transition-all duration-300 border border-border">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="font-playfair text-xl font-semibold text-card mb-1">{name}</h3>
          <p className="font-inter text-sm text-card/90">{role}</p>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="SparklesIcon" size={16} className="text-primary" variant="solid" />
          <span className="font-inter text-sm font-medium text-primary">
            {yearsMarried} Years of Marriage
          </span>
        </div>
        <blockquote className="font-inter text-sm text-foreground leading-relaxed italic">
          "{wisdom}"
        </blockquote>
      </div>
    </div>
  );
};

export default ElderWisdomCard;